import Input from "@mui/material/Input";
import "../../css/input.css";
//
export const InputElement = ({ label, id, className, error, ...props }) => {
  //
  const inputProps = { ...props };
  //
  return (
    <>
      <div className={`InputControl ${className}`} key={id}>
        <label htmlFor={id}>{label}</label>
        <Input
          id="_profile_input"
          htmlFor={id}
          inputProps={inputProps}
          error={error}
        />
      </div>
    </>
  );
};
